import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
import { Components } from '../utils/npm'
import Loader from '../components/Loader'

import { lazy, useEffect, useRef, useState } from "react";
import { setFooterLoad } from "../store/slice/masterSlice";
import { Footer, Header } from "./MyRoutes";

export const DashboardLayout = ({ children }) => {
  const fooerLoad = useSelector((state) => state.masterSlice.isloading);
  let scrolltoTopRef = useRef();
      const location = useLocation();
  
  const scrollView = () => {
    if (scrolltoTopRef.current) {
      scrolltoTopRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    scrollView()
    console.log('Children',children);
  }, [location?.pathname]);

  return (
    <>
      <div ref={scrolltoTopRef}>

        {/* <header> */}
        <Header />
        {/* </header> */}
        {children}
        <Outlet />
        {/* <Footer /> */}
      </div>
    </>
  );
};

export const WithoutHeader = ({ children }) => {
  const fooerLoad = useSelector((state) => state.masterSlice.isloading);

  const [reloadLoading, setReloadLoading] = useState(true);

  useEffect(() => {
    setReloadLoading(false)
  }, [])


  const layoutRef = useRef(null);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  let scrolltoTopRef = useRef();
  const scrollView = () => {
    if (scrolltoTopRef.current) {
      scrolltoTopRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    scrollView()
    console.log('Children',children);
  }, [children]);
  useEffect(() => {
    setReloadLoading(false)
  }, [])

  return (
    <>
    <div ref={scrolltoTopRef}>
      {/* <header> */}
      {/* <Header /> */}
      {/* </header> */}
      {children}
      <Outlet />
      {/* <Footer />  */}
      </div>
    </>
  );
};
